import {detach, flow, getEnv, resolveIdentifier, types} from "mobx-state-tree";
import {QrConfiguration} from "../../models/QrConfiguration";
import PreviewManager from "../../managers/preview/PreviewManager";
import Notification from "../../utils/Notification";
import {setDefaultBackgroundColor, setEyesAndModules} from "../../utils/common";
import {scannabilityCheck} from "../../utils/scannability";
import {TagModel} from "../../models/tags/TagModel";
import {DashboardStore} from "./DashboardStore";
import { buildMediaFileForImageConfig } from "../../utils/imageConfigHelper";
import { barcodeFormatConstants, PREVIEW_IMAGE_SIZE } from "src/utils/constants";

export const QrConfigStore = types.model('QrConfigStore',{
  storeUuid: types.identifier,
  defaultConfiguration:types.optional(types.array(QrConfiguration),[]), //dropdown
  alternateConfiguration: types.optional(types.array(types.frozen()),[]),
  configSelected: types.maybe(types.safeReference(QrConfiguration)),
  designerConfig: types.maybe(types.safeReference(QrConfiguration)),
  dashboardStore: types.maybe(types.reference(DashboardStore))
}).volatile((self)=>({
  filterListOn:types.fn,
})).actions((self)=>({
  setFilterOn(groupUuid) {
    console.log("Inside Config Store", groupUuid)
    self.filterListOn = (item) => {   //function used to filter tag options by selected group
      return item?.owner?.groupUuid === groupUuid
    }
  },
  initWithData(qrConfigs = []) {
    try {
      if (qrConfigs) {
        console.log("*** start initWithData,QrConfigStore");
        self.clearImageConfig();

        // Map new configs
        const newConfigs = qrConfigs.map(img => {
          //we dont need tags in dropdown store
          let nestedTags = [];
          // if(img.tags && img.tags.length > 0){
          //   nestedTags = img.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
          // }

          return QrConfiguration.create({
          uuid: img?.uuid,
          name: img?.name,
          label: img?.name,
          level: img?.level,
          image: img?.qrPreview || "",
          qrConfig: img?.data || "",
          is_default: img?.is_default,
          isExclusivelyGroupOwned: img?.isExclusivelyGroupOwned,
          createdAt: img?.createdAt,
          updatedAt: img?.updatedAt,
          //tags: nestedTags,
            owner: img?.owner,
            mediaFiles: img?.mediaFiles
        })});

        // Remove any existing configs with same UUIDs before adding new ones
        const newUuids = new Set(newConfigs.map(c => c.uuid));
        self.defaultConfiguration = [
          ...self.defaultConfiguration.filter(c => !newUuids.has(c.uuid)),
          ...newConfigs
        ].sort((a, b) => a.label.localeCompare(b.label));
      }

    } catch (e) {
      console.error("Failed to init QRConfigStore with data",e);
    }
  },
  addImageToList(imageConfig) {
    self.removeImageConfig();
    // Remove any existing config with the same UUID to prevent duplicates
    self.defaultConfiguration = self.defaultConfiguration.filter(
      config => config.uuid !== imageConfig.uuid
    );
    self.defaultConfiguration = [imageConfig, ...self.defaultConfiguration]
  },
  updateImageConfig(imageConfig) {
    const index = self.defaultConfiguration.findIndex(img => img.uuid === imageConfig?.uuid);
    if(index > -1) {
      let nestedTags = [];
      if(imageConfig.tags && imageConfig.tags.length > 0){
        nestedTags = imageConfig.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
      }
      imageConfig.tags=nestedTags;
      self.defaultConfiguration[index].updateConfig(imageConfig);
    }
  },
  removeImageConfig() {
    self.defaultConfiguration = self.defaultConfiguration.filter(img => img.level !== "qr");
  },
  clearImageConfig() {
    self.defaultConfiguration.forEach(item => {
      if(item.level !== "qr") {
        detach(item);
        self.defaultConfiguration.remove(item);
      }
    });
    //self.defaultConfiguration.clear();
  },
  // replaceImageConfig(qrConfigs) {
  //   self.clearImageConfig();
  //   const qrConfigurationObjects = qrConfigs.map(img =>{
  //     let nestedTags = [];
  //     if(img.tags && img.tags.length > 0){
  //       nestedTags = img.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
  //     }
  //     return ({
  //     uuid: img?.uuid || "",
  //     name: img?.name || "",
  //     label: img?.name || "",
  //     level: img?.level || "",
  //     image: img?.qrPreview || "",
  //     qrConfig: img?.data || "",
  //     is_default: img?.is_default || false,
  //     isExclusivelyGroupOwned: img?.isExclusivelyGroupOwned || false,
  //     createdAt: img?.createdAt || "",
  //     updatedAt: img?.updatedAt || "",
  //     tags: nestedTags,
  //     owner: img?.owner
  //   })});
  //
  //   qrConfigurationObjects.forEach(qrConfigObj => {
  //     const qrConfigInstance = QrConfiguration.create(qrConfigObj);
  //     self.defaultConfiguration.push(qrConfigInstance);
  //   });
  //   //self.defaultConfiguration.push(self.designerConfig)
  //   self.defaultConfiguration.sort((a,b) => a.label.localeCompare(b.label))
  // },

  fetchImageConfigWithIdAndUpdateStore: flow(function* f(uuid) {
    const res = yield getEnv(self).imageConfigManager.fetchWithId(uuid);
    self.updateImageConfig(res);
    return res;
  }),
  fetchImageConfigWithId: flow(function* f(uuid) {
      const res = yield getEnv(self).imageConfigManager.fetchWithId(uuid);
      if(res) {
        let nestedTags = [];
        if(res.tags && res.tags.length > 0){
          nestedTags = res.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
        }
        const imageConfig = QrConfiguration.create({
          uuid: res?.uuid,
          level: res?.level,
          name: res?.name,
          label: res?.name,
          image: res?.image,
          qrConfig: JSON.stringify(JSON.parse(res?.qrConfig)),
          is_default: res?.is_default,
          isExclusivelyGroupOwned: res?.isExclusivelyGroupOwned,
          createdAt: res?.createdAt,
          updatedAt: res?.updatedAt,
          tags: nestedTags,
          owner: res?.owner,
          mediaFiles: res?.mediaFiles,
          barcodeFormat: res?.barcodeFormat ? res.barcodeFormat : barcodeFormatConstants.QR_CODE
        })
        //self.designerConfig = imageConfig
        self.addImageToList(imageConfig);
        return res;
      }
  }),

  // init: flow(function* f(params = {}) {
  //   console.log("load configStore from API");
  //   yield self.getQRConfigs(params);
  // }),
  // getQRConfigs: flow(function* getDomains(params = {}) {
  //   try {
  //     const imageConfigResponse = yield getEnv(self).imageConfigManager.fetchAll(params);
  //     if(imageConfigResponse && imageConfigResponse.results && imageConfigResponse.results.length > 0) {
  //       self.defaultConfiguration = imageConfigResponse.results.map(img =>
  //       {
  //         let nestedTags = [];
  //         if(img.tags && img.tags.length > 0){
  //           nestedTags = img.tags.map(t => resolveIdentifier(TagModel, self, t?.uuid))
  //         }
  //         return QrConfiguration.create({
  //         uuid: img?.uuid,
  //         name: img?.name,
  //         label: img?.name,
  //         level: img?.level,
  //         image: img?.qrPreview,
  //         qrConfig:img?.data,
  //         is_default: img?.is_default,
  //         isExclusivelyGroupOwned: img?.isExclusivelyGroupOwned,
  //         createdAt: img?.createdAt,
  //         updatedAt: img?.updatedAt,
  //         tags: nestedTags,
  //         owner: img?.owner
  //       })}).sort((a, b) => a.label.localeCompare(b.label))
  //     }
  //
  //     return imageConfigResponse;
  //   } catch (error) {
  //     console.error("Failed to fetch image configs", error);
  //     return null;
  //   }
  // }),
  selectGroup(obj) {
    self.configSelected = obj.uuid;
  },
  setConfigStore(configs){
    self.alternateConfiguration = configs
  },
  setDesignerConfig(c) {
      self.designerConfig =  c
  },
  makeAllUserDimension(dimensions) {
    const result = {};
    dimensions.forEach(dimension => {
      result[dimension.uuid] = [];
    });
    return result;
  },
  addConfig: flow(function* f(state) {
    let extendConfig = JSON.parse(state.extendConfig)
    let configBarcodeFormat = state.barcodeFormat
    setDefaultBackgroundColor(extendConfig)
    setEyesAndModules(extendConfig)
    state.updateExtendConfig("addThreeEyelidColors", state.colorStore.addThreeEyelidColors)
    setDefaultBackgroundColor(extendConfig)
    setEyesAndModules(extendConfig)
    const formDataForIcon = JSON.stringify({...extendConfig ,size: PREVIEW_IMAGE_SIZE.size, resolution: PREVIEW_IMAGE_SIZE.resolution, unitsOfMeasure: PREVIEW_IMAGE_SIZE.unit, showImageSizeOrModuleWidth: true})
    const configForIcon = {
      name:state.configurationName,
      qrImageFormData:formDataForIcon,
      shortUrl:""
    }

    const dimensionStore = state.dimensionsMultiSelectStore.dimensionStore
    let config = {
      name:state.configurationName,
      qrImageFormData:JSON.stringify(extendConfig),
      isExclusivelyGroupOwned: state.isExclusivelyGroupOwned,
      groupUuid:state.groupSelectStore.selectedGroup.uuid,
      tags: state.selectedTags,
      dimensions: dimensionStore.dimensionsEnabled
        ? state.dimensionsMultiSelectStore.getTranspiledDimensions()
        : self.makeAllUserDimension(dimensionStore.getDimensions()),
      barcodeFormat: configBarcodeFormat
    }

    // check logo and background media files
    config.mediaFiles = buildMediaFileForImageConfig(state.logoStore)

    let isDefaultDesignerConfig = true
    if (extendConfig.isDefaultDesigner === false) {
      isDefaultDesignerConfig = extendConfig.isDefaultDesigner
    }

    try {
      const designerHttpClient = getEnv(state).httpClient; // Use authenticated httpClient from environment
      const previewManager = new PreviewManager(designerHttpClient, state.defaultImageConfig, state.v1ImageConfig)
      const isSavingConfig = true
      const resp = yield previewManager.create(configForIcon, isSavingConfig)
      if (resp.status >= 200 && resp.status < 300) {
        //add call to the design manager
        let qrPreview = resp.base64Image
        // need to check if the image is scannable
        if(isDefaultDesignerConfig) {
          const previewConfig = yield previewManager.create(config)
          const scanabilityCheck = yield scannabilityCheck(previewConfig.base64Image)
        }
        const configImagePayload = { ...config,
          "qrPreview":qrPreview}
        const imageConfigManager = getEnv(self).imageConfigManager
        const res = yield imageConfigManager.create(configImagePayload)
        const newConfig = QrConfiguration.create({
          uuid: res.data.uuid,
          label: res.data.name,
          level: res.data?.level,
          name: res.data.name,
          qrConfig: res.data.data,
          image: res.data.qrPreview,
          isExclusivelyGroupOwned: res.data?.isExclusivelyGroupOwned,
          tags: res.tags,
          owner: res.data?.owner,
          mediaFiles: res.data?.mediaFiles,
          barcodeFormat: res.data?.barcodeFormat
        })
        self.defaultConfiguration.push(newConfig)
        return resp.status
      }else{
        return resp.status
      }
    } catch (error) {
      console.error("Failed to add image config", error);
      return null;
    }
  }),
  deleteConfig(uuid){
    const config = self.defaultConfiguration.find(el => el.uuid === uuid)
    for (let el of self.defaultConfiguration) {
        if (el.uuid === uuid) {
          const indexOf = self.defaultConfiguration.indexOf(el)
          self.defaultConfiguration.splice(indexOf, 1)
        }
      }
    new Notification()
      .setType("success")
      .setMessage(`${config?.name} Designer Template deleted`)
      .send();

  }
})).views((self) => ({
  filteredList() {
      return self.defaultConfiguration || []
  }
}));
